/**
 * Dexieから新しいZustand/IndexedDBストアへのデータ移行
 */
import Dexie from 'dexie'
import type { SavedRelationship } from '@creanizer/types'

class OldRelationshipDatabase extends Dexie {
  relationships!: Dexie.Table<SavedRelationship>

  constructor() {
    super('RelationshipDatabase')
    this.version(1).stores({
      relationships: 'id, title, createdAt, updatedAt'
    })
  }
}

export async function migrateRelationshipData(): Promise<SavedRelationship[]> {
  try {
    console.log('🔄 既存のDexieデータベースから関係性データを移行中...')
    
    const oldDb = new OldRelationshipDatabase()
    const relationships = await oldDb.relationships.toArray()
    
    if (relationships.length > 0) {
      console.log(`✅ ${relationships.length}件の関係性データを移行しました`)
      
      // 移行後、古いデータベースを削除
      await oldDb.delete()
      console.log('✅ 古いDexieデータベースを削除しました')
    } else {
      console.log('ℹ️ 移行するデータがありません')
    }
    
    oldDb.close()
    return relationships
  } catch (error) {
    console.log('ℹ️ Dexieデータベースが存在しないか、既に移行済みです')
    return []
  }
}